export default __webpack_public_path__ + "alberta-activities-sort-past.e5e89e22e1fe77c7c7a0.svg";